import { render, staticRenderFns } from "./itemPage.vue?vue&type=template&id=b1c46048&scoped=true&"
import script from "./itemPage.vue?vue&type=script&lang=js&"
export * from "./itemPage.vue?vue&type=script&lang=js&"
import style0 from "./itemPage.vue?vue&type=style&index=0&id=b1c46048&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1c46048",
  null
  
)

export default component.exports